import React, { useState } from 'react';

interface VideoThumbnailProps {
  src?: string;
  alt: string;
  duration?: string;
  isLive?: boolean;
  className?: string;
  onClick?: () => void;
  fallbackIcon?: string;
}

const VideoThumbnail: React.FC<VideoThumbnailProps> = ({
  src,
  alt,
  duration,
  isLive = false,
  className = '',
  onClick,
  fallbackIcon = '⚽'
}) => {
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(!!src); // Only show loading if we have a src

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setIsLoading(false);
  };

  return (
    <div 
      className={`relative aspect-video bg-gray-200 rounded-lg overflow-hidden group cursor-pointer ${className}`}
      onClick={onClick}
    >
      {/* Image or Fallback */}
      {src && !imageError ? (
        <>
          {/* Loading State - only show when we have a src */}
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
              <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            </div>
          )}
          <img
            src={src}
            alt={alt}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
        </>
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200">
          <div className="text-6xl opacity-60">{fallbackIcon}</div>
        </div>
      )}


      {/* Duration Badge */}
      {duration && !isLive && (
        <div className="absolute bottom-2 right-2 bg-black bg-opacity-75 text-white text-xs px-2 py-1 rounded">
          {duration}
        </div>
      )}

    </div>
  );
};

export default VideoThumbnail;
